import React from 'react';
import { useTranslation } from 'react-i18next';
import { useResponsive } from '@app/hooks/useResponsive';
import { StatisticColor } from '@app/constants/config/statistics';
import * as S from './StatisticsCard.styles';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { FirmInfo } from '../StatisticsInfo/FirmInfo';

interface StatisticsCardProps {
  name: string;
  color: StatisticColor;
  Icon: React.FC;
}

export const FirmCard: React.FC<StatisticsCardProps> = ({ name, color, Icon }) => {
  const { isTablet: isTabletOrHigher } = useResponsive();

  const { t } = useTranslation();

  return (
    <S.StatisticCard padding="0.5rem" $color={color}>
      <BaseRow wrap={false} gutter={[isTabletOrHigher ? 10 : 5, 0]}>
        <BaseCol>
          <S.IconWrapper>
            <S.Icon component={Icon} />
          </S.IconWrapper>
        </BaseCol>

        <BaseCol flex={1}>
          <BaseRow justify="space-between" align="middle" wrap={false} style={{ paddingTop: '10px' }}>
            <BaseCol>
              <FirmInfo name={t(name)} />
            </BaseCol>
          </BaseRow>
        </BaseCol>
      </BaseRow>
    </S.StatisticCard>
  );
};
